module.exports = __webpack_public_path__ + "static/Gremlinz-White-Transp.54c275c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Gremlinz/Gremlinz-White-Transp.png
// module id = 1693
// module chunks = 249972491463148